import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllSecondaryCollectionTransaction } from "../../../Apis/TransferStationReport/secondaryCollectionTransactionApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1, getToken } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { exportToPDF } from "../../../../utils/exportToPDF";
import SmallLoader from "../../../../Hooks/SmallLoader";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL, API_BASE_URL1 } from "../../../Services/baseApiUrl";

const SecondaryCollectionTransaction = ({ t }) => {
  const headers = [
    "routePointName",
    "routePointType",
    "vehicleUid",
    "vehicleNumber",
    "zone",
    // "circle",
    "ward",
    "vehicleType",
    "ownerType",
    "shift",
    "driverName",
    "deploymentDate",
    "beforeLatitude",
    "afterLatitude",
    "beforeLongitude",
    "afterLongitude",
    "beforeAddress",
    "afterAddress",
    "beforeImage",
    "afterImage",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [allZones, setAllZones] = useState("");
  const [zoneId, setZoneId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [IsExcelDowanload, setIsExcelDowanload] = useState(false);
  const isProd = isGHMC();

  const fetchAllZoneData = async () => {
    try {
      const zonesData = await GetZone();
      const delhiZones = (Array.isArray(zonesData) ? zonesData : []).filter(
        (zone) =>
          zone.isActive !== false &&
          String(zone.zoneName || "").toLowerCase().includes("delhi")
      );
      setAllZones(delhiZones);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchAllZoneData();
    fetchTripsTonnageData(startDate, endDate, zoneId, vehicleNumber);
  }, []);

  useEffect(() => {
    const zones = Array.isArray(allZones) ? allZones : [];
    if (zones.length === 0) return;

    setZoneId((currentZoneId) =>
      currentZoneId ? currentZoneId : String(zones[0].zoneId)
    );
  }, [allZones]);

  const fetchTripsTonnageData = async (
    startDate,
    endDate,
    zoneId,
    vehicleNumber,
  ) => {
    setIsLoading(true);
    try {
      const response = await AllSecondaryCollectionTransaction(
        startDate,
        endDate,
        zoneId,
        vehicleNumber,
      );
      const formattedData = response.data.map((item) => ({
        ...item,
        vehicleUid: item.vehicleUuid || "N/A",
        beforeImage: item.beforeImageUrl ?? "N/A",
        afterImage: item.afterImageUrl || "N/A",
        beforeLatitude: item.beforeLatitude || "N/A",
        beforeLongitude: item.beforeLongitude || "N/A",
        afterLatitude: item.afterLatitude || "N/A",
        afterLongitude: item.afterLongitude || "N/A",
        deploymentDate: item.beforeDateTime || "N/A",
        zone: item.zoneName || "N/A",
        ward: item.circleName || "N/A",
        // ward: item.wardName || "N/A",
        shift: item.shiftName || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        ownerType: item.ownerTypeName || "N/A",
        beforeAddress: item.beforeAddress || "N/A",
        afterAddress: item.afterAddress || "N/A",
        routePointName: item.collectionPointName || "N/A",
        routePointType: item.collectionPointType || "N/A",
        routePointCode: item.collectionPointCode || "N/A",
        routeCode: item.routeCode || "N/A",
      }));
      setAllTripsTonnage(formattedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate, zoneId, vehicleNumber);
  };

  // Function to format dates for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Collection Transaction Reports ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report Generated on: ${generationTime}, ${formattedTime}`;
    const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    const boldFont = { bold: true };

    // Add Report Generation Date
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 13);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 13; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // // Add Date Range
    // worksheet.addRow(["", "", dateRange, ""]);
    // worksheet.mergeCells(2, 2, 2, 13);
    // worksheet.getCell(2, 2).value = dateRange;
    // worksheet.getCell(2, 2).font = boldFont;
    // worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 13; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add Report Title
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(3, 2, 3, 13);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 13; col++) {
      worksheet.getCell(3, col).font = boldFont;
      worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Point Name",
      "Waste Type",
      "Vehicle UID",
      "Vehicle Number",
      "Zone",
      // "Circle",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "Shift",
      "Driver Name",
      "Deployment Date",
      "Before Latitude",
      "After Latitude",
      "Before Longitude",
      "After Longitude",
      "Before Address",
      "After Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 22) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.collectionPointName || "N/A",
          item.collectionPointType || "N/A",
          item.vehicleUuid ?? "N/A",
          item.vehicleNumber ?? "N/A",
          item.zoneName ?? "N/A",
          item.circleName ?? "N/A",
          // item.wardName ?? "N/A",
          item.vehicleTypeName ?? "N/A",
          item.ownerTypeName ?? "N/A",
          item.shiftName ?? "N/A",
          item.driverName ?? "N/A",
          item.beforeDateTime ?? "N/A",
          item.beforeLatitude ?? "N/A",
          item.afterLatitude ?? "N/A",
          item.beforeLongitude ?? "N/A",
          item.afterLongitude ?? "N/A",
          item.beforeAddress ?? "N/A",
          item.afterAddress ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 22) {
            cell.alignment = {
              horizontal: "left",
              vertical: "middle",
              wrapText: true,
            };
          } else {
            cell.alignment = {
              horizontal: "center",
              vertical: "middle",
              wrapText: true,
            };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CollectionTransaction.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const dowanloadExcel = async () => {
    setIsExcelDowanload(true);
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}RawReport/GetAllSecondaryCollectionTransactionExcelSheet`,
        {
          params: {      
           startDate,
           endDate,
            ZoneId: zoneId,
            VehicleNumber: vehicleNumber,
          },
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
          responseType: "blob", // 🔥 VERY IMPORTANT
        },
      );

      // ✅ Create downloadable file
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Collection Transaction.xlsx"; // or backend filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsExcelDowanload(false);
    }
  };

  const exportPdf = async () => {
    await exportToPDF({
      fileName: "Collection_Transaction_Report",
      title: "Collection Transaction Reports",
      generatedOnText: `Report Generated on: ${generationTime}, ${getCurrentDateTime1()}`,
      data: getAllTripsTonnage,
      landscape: true,
      headFillColor: [4, 53, 85],
      headTextColor: [255, 255, 255],
      columns: [
        {
          header: "S.No",
          accessor: (_row, index) => index + 1,
          width: 10,
        },
        {
          header: "Point Name",
          accessor: (row) => row.collectionPointName || "N/A",
          width: 30,
        },
        {
          header: "Waste Type",
          accessor: (row) => row.collectionPointType || "N/A",
          width: 28,
        },
        {
          header: "Vehicle UID",
          accessor: (row) => row.vehicleUuid ?? "N/A",
          width: 30,
        },
        {
          header: "Vehicle Number",
          accessor: (row) => row.vehicleNumber ?? "N/A",
          width: 25,
        },
        {
          header: "Zone",
          accessor: (row) => row.zoneName ?? "N/A",
          width: 22,
        },
        {
          header: "Ward",
          accessor: (row) => row.circleName ?? "N/A",
          width: 22,
        },
        {
          header: "Vehicle Type",
          accessor: (row) => row.vehicleTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "Owner Type",
          accessor: (row) => row.ownerTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "Shift",
          accessor: (row) => row.shiftName ?? "N/A",
          width: 20,
        },
        {
          header: "Driver Name",
          accessor: (row) => row.driverName ?? "N/A",
          width: 28,
        },
        {
          header: "Deployment Date",
          accessor: (row) => formatDateForDisplay(row.beforeDateTime) ?? "N/A",
          width: 28,
        },
        {
          header: "Before Latitude",
          accessor: (row) => row.beforeLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "After Latitude",
          accessor: (row) => row.afterLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "Before Longitude",
          accessor: (row) => row.beforeLongitude ?? "N/A",
          width: 22,
        },
        {
          header: "After Longitude",
          accessor: (row) => row.afterLongitude ?? "N/A",
          width: 22,
        },
        {
          header: "Before Address",
          accessor: (row) => row.beforeAddress ?? "N/A",
          width: 60,
        },
        {
          header: "Before Address",
          accessor: (row) => row.afterAddress ?? "N/A",
          width: 60,
        },
      ],
    });
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">
              {t("Collection Transaction")} (
              {formatDateForDisplay(startDate)} to{" "}
              {formatDateForDisplay(endDate)}) - (at {getCurrentDateTime1()})
            </h4>

            <div className="card">
              <div className="card-body p-3">
                <form onSubmit={handleFormSubmit}>
                  <div className="row align-items-end">
                    <div className="col-md-9">
                      <div className="row" style={{ textAlign: "left" }}>
                        <div className="col-md-3">
                          <label>From Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className="form-control"
                            max={endDate ? endDate : getCurrentDateTime()}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>To Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            className="form-control"
                            value={endDate}
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-3">
                          <label>Vehicle Number</label>
                          <input
                            type="text"
                            name="vehicleTypeCode"
                            style={inputStyle}
                            placeholder="Vehicle Number"
                            className="form-control"
                            value={vehicleNumber}
                            onChange={(e) => {
                              setVehicleNumber(
                                e.target.value.replace(/\s+/g, ""),
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3" style={{ display: "none" }}>
                          <label htmlFor="ZoneId">Zone:</label>
                          <select
                            name="ZoneId"
                            className="form-select"
                            value={zoneId}
                            onChange={(e) => setZoneId(e.target.value)}
                          >
                            {Array.isArray(allZones) &&
                              allZones.map((zone) => (
                                <option key={zone.zoneId} value={zone.zoneId}>
                                  {zone.zoneName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="d-flex justify-content-between align-items-end">
                        <button
                          type="submit"
                          className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                        >
                          Search
                        </button>
                        <button
                          className="btn btn-excel ms-auto mt-4"
                          onClick={dowanloadExcel}
                        >
                          {IsExcelDowanload ? <SmallLoader /> : <span>
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                            Excel
                          </span>}
                        </button>

                        <button
                          className="btn btn-excel ms-auto mt-4"
                          onClick={exportPdf}
                        >
                          <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                          Pdf
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

                <div className="mt-3">
                  <TableComponent isLoading={isLoading}
                    DataFetchURL={getAllTripsTonnage}
                    headers={headers}
                    headerLabels={{
                      routePointName: "Point Name",
                      routePointType: "Waste Type",
                    }}
                    imgField={["beforeImage", "afterImage"]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

export default withTranslation()(SecondaryCollectionTransaction);
